<template>
  <v-card>
    <v-card-title class="v-card">
      <span class="headline">Detalhes</span>
      <v-spacer />
      <v-btn type="button" color="primary" @click="$emit('close')"
        >Fechar</v-btn
      >
    </v-card-title>
    <v-card-text>
      <v-timeline
        v-if="senhas.length > 0"
        class="px-2 py-8"
        :dense="$vuetify.breakpoint.smAndDown"
      >
        <v-timeline-item
          v-for="(item, index) of [...senhas].reverse()"
          :key="index"
        >
          <v-card class="elevation-2 pa-4">
            <v-card-text>
              <div>
                <span>
                  Sequência:
                  <strong>{{ item.sequencia }}</strong></span
                >
              </div>
              <div>
                <span>
                  Evento:
                  <strong>{{ item.evento }}</strong>
                </span>
              </div>
              <div>
                <span>
                  Data:
                  <strong>{{ item.timestamp | toBrazilianDateTime }}</strong>
                </span>
              </div>
              <div>
                <span>
                  Gerado Por:
                  <strong>{{ item.gerado_por }}</strong>
                </span>
              </div>
              <div>
                <span>
                  Para:
                  <strong>{{ item.objeto }}</strong>
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
      <div v-else class="text-center py-8">
        <span class="subtitle-1">Nenhum histórico de senha encontrado.</span>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { toBrazilianDateTime } from '@/mixins/convertion'

export default {
  props: {
    senhas: {
      type: Array,
      required: true,
    },
  },
  filters: {
    toBrazilianDateTime(item) {
      if (item == null) return ''
      return toBrazilianDateTime(item)
    },
  },
}
</script>

<style>
.v-timeline-item:last-child {
  padding-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
.v-card {
  .v-card__text {
    padding-bottom: 0;
  }
}
</style>
